import React, { useState } from 'react';




const ConversationTable = ({ conversations, onViewDetails }) => {
  const [expandedRow, setExpandedRow] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: 'timestamp', direction: 'desc' });
  const itemsPerPage = 10;

  const getStatusColor = (status) => {
    const colors = {
      'ai-resolved': 'bg-success/10 text-success border-success/20',
      'escalated': 'bg-warning/10 text-warning border-warning/20',
      'abandoned': 'bg-error/10 text-error border-error/20',
      'pending': 'bg-muted text-muted-foreground border-border'
    };
    return colors?.[status] || colors?.pending;
  };

  const getStatusIcon = (status) => {
    const icons = {
      'ai-resolved': 'CheckCircle2',
      'escalated': 'ArrowUpCircle',
      'abandoned': 'XCircle',
      'pending': 'Clock'
    };
    return icons?.[status] || 'Clock';
  };

  const handleSort = (key) => {
    setSortConfig({
      key,
      direction: sortConfig?.key === key && sortConfig?.direction === 'asc' ? 'desc' : 'asc'
    });
  };

  const sortedConversations = [...conversations]?.sort((a, b) => {
    if (sortConfig?.key === 'timestamp') {
      return sortConfig?.direction === 'asc' ?
      new Date(a.timestamp) - new Date(b.timestamp) :
      new Date(b.timestamp) - new Date(a.timestamp);
    }
    if (sortConfig?.key === 'duration') {
      return sortConfig?.direction === 'asc' ?
      a?.duration - b?.duration :
      b?.duration - a?.duration;
    }
    if (sortConfig?.key === 'satisfaction') {
      return sortConfig?.direction === 'asc' ?
      a?.satisfaction - b?.satisfaction :
      b?.satisfaction - a?.satisfaction;
    }
    return 0;
  });

  const totalPages = Math.ceil(sortedConversations?.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedConversations = sortedConversations?.slice(startIndex, startIndex + itemsPerPage);

  const formatDuration = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}m ${secs}s`;
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    return date?.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50">
            <tr>
              








              


              


              


              








              


              








              


            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {paginatedConversations?.map((conversation) =>
            <React.Fragment key={conversation?.id}>
                <tr className="hover:bg-muted/30 transition-base">
                  


                  












                  


                  




                  


                  





                  





                  

















                </tr>
                {expandedRow === conversation?.id &&
              <tr>
                    <td colSpan="8" className="px-4 md:px-6 py-4 bg-muted/20">
                      <div className="space-y-4">
                        <div>
                          <p className="text-xs font-medium text-muted-foreground mb-2">Conversation Summary</p>
                          <p className="text-sm text-foreground">{conversation?.summary}</p>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                          <div>
                            <p className="text-xs font-medium text-muted-foreground mb-1">Resolution Path</p>
                            <p className="text-sm text-foreground">{conversation?.resolutionPath}</p>
                          </div>
                          <div>
                            <p className="text-xs font-medium text-muted-foreground mb-1">Key Topics</p>
                            <div className="flex flex-wrap gap-1">
                              {conversation?.keyTopics?.map((topic, index) =>
                          <span key={index} className="px-2 py-0.5 rounded-full bg-primary/10 text-primary text-xs">
                                  {topic}
                                </span>
                          )}
                            </div>
                          </div>
                          <div>
                            <p className="text-xs font-medium text-muted-foreground mb-1">Sentiment</p>
                            <p className="text-sm text-foreground capitalize">{conversation?.sentiment}</p>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
              }
              </React.Fragment>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );

};

export default ConversationTable;